export enum SearchType {
  BENCHMARKS = 'Benchmarks',
  FUNDS = 'Funds',
}
